module.exports = __webpack_public_path__ + "img/1f3ae.3104468.svg";